<template>
  <div class="info-panel">
    <form @submit.prevent="searchVehicle">
      <div class="border rounded p-4 mb-5">
        <div class="row">
          <span class="text-gray-700 mb-2">Выберите способ поиска:</span>
          <div class="col-6" v-if="filterSettings.type.show">
            <radio-field
                v-model="filter.type"
                :value="0"
                :disabled="filterSettings.type.disabled"
                placeholder="Номер свидетельства"
                type="radio"
                id="vehicle.filter.type_number"
                class="form-check-sm"
            ></radio-field>
          </div>
          <div class="col-6" v-if="filterSettings.type.show">
            <radio-field
                v-model="filter.type"
                :value="1"
                :disabled="filterSettings.type.disabled"
                placeholder="VIN"
                type="radio"
                id="vehicle.filter.type_vin"
                class="form-check-sm"
            ></radio-field>
          </div>
        </div>
      </div>
      <template v-if="filter.type !== null">
        <div class="row">
          <div class="col-md-6" v-if="searchSettings.number.show">
            <input-field
              v-model="search.number"
              id="search.number"
              name="search.number"
              :has-error="hasCar"
              :disabled="searchSettings.number.disabled"
              :required="searchSettings.number.required"
              placeholder="Гос. номер авто"
              @input="search.number=$event.target.value.toUpperCase()"
              type="text"
              mb="5">
          </input-field>
          </div>
          <div class="col-md-6" v-if="searchSettings.vin.show || searchSettings.certificate.show">
            <template v-if="searchSettings.certificate.show">
              <input-field
                  v-model="search.certificate"
                  id="search.certificate"
                  name="search.certificate"
                  :has-error="hasCar"
                  :disabled="searchSettings.certificate.disabled"
                  :required="searchSettings.certificate.required"
                  placeholder="Номер свидетельства"
                  @input="search.certificate=$event.target.value.toUpperCase()"
                  type="text"
                  mb="5">
              </input-field>
            </template>
            <template v-if="searchSettings.vin.show">
              <input-field
                  v-model="search.vin"
                  id="search.vin"
                  name="search.vin"
                  :has-error="hasCar"
                  :disabled="searchSettings.vin.disabled"
                  :required="searchSettings.vin.required"
                  placeholder="VIN"
                  @input="search.vin=$event.target.value.toUpperCase()"
                  type="text"
                  mb="5">
              </input-field>
            </template>
          </div>
        </div>
        <div v-if="hasCar" class="text-danger text-center opacity-75">
          Данное ТС уже добавлено.
        </div>
        <button
            v-if="!hasCar && (search.number && (search.certificate || search.vin))"
            title="Поиск"
            type="submit"
            class="btn btn-sm btn-primary w-100"
            :disabled="this.loading || this.hasCar"
            v-html="this.loading ? 'Идет поиск...' : 'Поиск'">
        </button>
      </template>
    </form>
  </div>
</template>

<script>
// Field
import InputField     from '@/components/Fields/InputField.vue'
import RadioField     from "@/components/Fields/RadioButtonField.vue";

export default {
  name: 'VehicleBpmSearch',
  props: {
    isClear: {
      type: Boolean,
      default: false
    },
    carAddedList: {
      type: Array,
      default: () => []
    },
    module: {
      typ: Function,
      required: true
    },
    searchData: {
      type: Object,
      default: null
    },
    processId: {
      type: String,
      default: null
    },
    mode: {
      type: [Object, Function],
      required: true
    }
  },
  components: {RadioField, InputField},
  data () {
    const filter = this.module.Vehicle.filterFields()
    const filterSettings = this.module.Vehicle.filterFieldsSettings(filter.type)
    const search = this.module.Vehicle.searchFields()
    const searchSettings = this.module.Vehicle.searchFieldsSettings(filter.type)
    return {
      filter:       filter,
      filterSettings: filterSettings,
      search:       search,
      searchSettings: searchSettings,
      errorMessage: null,
      loading:      false,
      hasCar:       false,
      step:         0,
    }
  },
  methods: {
    searchVehicle() {
      this.$emit('search-vehicle', {search: this.search, filter: this.filter, processId: this.processId})
    },
    clearForm() {
      this.filter       = this.module.Vehicle.filterFields()
      this.search       = this.module.Vehicle.searchFields()
      this.errorMessage = null
      this.loading      = false
      this.step         = 0
    },
  },
  watch: {
    'filter.type': {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.search.vin = null
        this.search.certificate = null
        this.searchSettings = this.module.Vehicle.searchFieldsSettings(newValue)
      }
    },
    search: {
      deep: true,
      handler() {
        this.hasCar = this.carAddedList.indexOf(this.search.vin) >= 0 || this.carAddedList.indexOf(this.search.number) >= 0 || this.carAddedList.indexOf(this.search.certificate) >= 0
      }
    },
    isClear: {
      deep: true,
      handler(val) {
        if (val) {
          this.clearForm()
        }
      }
    },
    searchData: {
      deep: true,
      handler(val) {
        if (val) {
          this.search = val
        }
      }
    },
    'search.number': {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.search.number = val.replaceAll(/[^\p{L}\p{N}]/gu, '');
          });
        }
      }
    },
    'search.vin': {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.search.vin = val.replaceAll(/[^\p{L}\p{N}]/gu, '');
          });
        }
      }
    }
  }
}
</script>

<style scoped>

</style>